// extracted by mini-css-extract-plugin
export default {"detailsPackagePage_wrapper_detailsPackage":"DetailsPackagePage_detailsPackagePage_wrapper_detailsPackage__XGZui"};